import { useState, useMemo, useEffect, useRef } from 'react';
import { D, st, toArr, calcTotal } from '../constants';

export default function GlobalSearch({clients, invoices, bids, jobs, clientName, fmt, fmtDate, onNavigate}) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const inputRef = useRef();

  const results = useMemo(() => {
    if (!q.trim() || q.length < 2) return [];
    const s = q.toLowerCase();
    const out = [];

    toArr(clients).filter(c => (c.name||"").toLowerCase().includes(s) || (c.email||"").toLowerCase().includes(s) || (c.phone||"").includes(s)).slice(0,3).forEach(c =>
      out.push({type:"client", icon:"👤", label:c.name, sub:c.email||c.phone||"", item:c}));

    toArr(invoices).filter(i => (i.number||"").toLowerCase().includes(s) || (clientName(i.clientId)||"").toLowerCase().includes(s)).slice(0,3).forEach(i =>
      out.push({type:"invoice", icon:"🧾", label:i.number, sub:`${clientName(i.clientId)} · ${fmt(calcTotal(i.items))} · ${i.status}`, item:i}));

    toArr(bids).filter(b => (b.number||"").toLowerCase().includes(s) || (b.description||"").toLowerCase().includes(s) || (clientName(b.clientId)||"").toLowerCase().includes(s)).slice(0,3).forEach(b =>
      out.push({type:"bid", icon:"📋", label:b.number, sub:`${clientName(b.clientId)} · ${b.status}`, item:b}));

    toArr(jobs).filter(j => (j.title||"").toLowerCase().includes(s) || (clientName(j.clientId)||"").toLowerCase().includes(s)).slice(0,3).forEach(j =>
      out.push({type:"job", icon:"🔧", label:j.title, sub:`${clientName(j.clientId)} · ${j.status} · ${fmtDate(j.date)}`, item:j}));

    return out.slice(0,10);
  }, [q, clients, invoices, bids, jobs]);

  useEffect(() => { setOpen(q.length >= 2 && results.length > 0); }, [q.length, results.length]);

  const handleKey = e => { if (e.key === "Escape") { setQ(""); setOpen(false); } };

  return (
    <div style={{position:"relative", marginBottom:20, zIndex:40}}>
      <div style={{position:"relative", maxWidth:500}}>
        <span style={{position:"absolute",left:10,top:"50%",transform:"translateY(-50%)",color:D.muted,fontSize:14,pointerEvents:"none"}}>🔍</span>
        <input ref={inputRef} value={q} onChange={e=>setQ(e.target.value)} onKeyDown={handleKey}
          onBlur={()=>setTimeout(()=>setOpen(false),200)}
          placeholder="Search clients, invoices, jobs, bids..."
          style={{...st.input,paddingLeft:32,fontSize:13,width:"100%"}}/>
        {q && <button onClick={()=>{setQ("");setOpen(false);}} style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",color:D.muted,cursor:"pointer",fontSize:14}}>×</button>}
      </div>
      {open && results.length > 0 && (
        <div style={{position:"absolute",top:"100%",left:0,width:"min(500px,calc(100vw - 40px))",background:D.card,border:`1px solid ${D.border}`,borderRadius:10,boxShadow:"0 8px 24px rgba(0,0,0,0.4)",zIndex:50,overflow:"hidden"}}>
          {results.map((r,i) => (
            <div key={i} onMouseDown={()=>{onNavigate(r.type,r.item);setQ("");setOpen(false);}}
              style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",cursor:"pointer",borderBottom:`1px solid ${D.border}`,background:"transparent"}}
              onMouseEnter={e=>e.currentTarget.style.background=D.surface}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <span style={{fontSize:16,flexShrink:0}}>{r.icon}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,fontWeight:600,color:D.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.label}</div>
                <div style={{fontSize:11,color:D.muted,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.sub}</div>
              </div>
              <span style={{fontSize:10,color:D.muted,flexShrink:0,textTransform:"capitalize"}}>{r.type}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
